export default (userAgent) => {
  const isMobile = userAgent.isMobile && !userAgent.isTablet;
  return { ...userAgent, isMobile };
};
